import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import axios from 'axios';

import _ from 'helpers/no_conflict_lodash';

import './styles.scss';
import { tagProps } from './tag_table';

export default function ConfirmDeleteTagsModal({ databaseId, modalDisplay, selectedTags, onCloseModal, onDeleteTags }) {
  const handleSave = () => {
    const deleteTagIds = selectedTags.map(tag => (tag.id));

    return axios.post(`/database_settings/${databaseId}/tags/delete`, {
      delete_ids: deleteTagIds
    }).then((response) => {
      onDeleteTags(response.data);
      onCloseModal();
    }).catch((errors) => {
      console.warn(errors)
    });
  };

  const countData = () => {
    const mappedInstanceCount = _.map(selectedTags, tag => (
      tag.recordCountByType.totalCount
    ));

    const totalInstances = _.reduce(mappedInstanceCount, (sum, instances) => {
      return sum + instances;
    }, 0);

    return { totalTags: selectedTags.length, totalInstances: totalInstances };
  };

  const renderTagInstanceMessage = () => {
    const countedData = countData();
    const totalTags = countedData.totalTags === 1 ? `1 tag` : `${countedData.totalTags} tags`;
    let instanceMessage;

    if (countedData.totalInstances > 0) {
      const pluralize = countedData.totalInstances === 1 ? '1 instance' : `${countedData.totalInstances} instances`;
      instanceMessage = <span> with <strong>{pluralize}</strong></span>;
    }

    return (
      <p className="label-light">
        You are about to delete <strong>{totalTags}</strong>{instanceMessage}. Are you sure you want to delete?
      </p>
    );
  };


  const renderTagForm = () => {
    return (
      <div className="form-group">
        {renderTagInstanceMessage()}
        <p>This action is permanent and cannot be undone.</p>
      </div>
    );
  };

  const renderTagFooter = () => {
    return (
      <div>
        <button className="btn btn-cancel btn-sm" name="cancel" onClick={onCloseModal}>
          Cancel
        </button>
        <button className="btn btn-danger btn-sm" name="delete" onClick={handleSave}>
          Yes, Delete Tags
        </button>
      </div>
    );
  };

  return (
    <Modal
      bsSize="sm"
      name="tag-form-modal"
      show={modalDisplay}
      onHide={onCloseModal}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Confirm Delete
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="tags-modal-body">
          {renderTagForm()}
        </div>
        <div className="tags-modal-actions">
          {renderTagFooter()}
        </div>
      </Modal.Body>
    </Modal>
  );
}

ConfirmDeleteTagsModal.propTypes = {
  databaseId: PropTypes.number.isRequired,
  modalDisplay: PropTypes.bool,
  selectedTags: PropTypes.arrayOf(tagProps).isRequired,
  onCloseModal: PropTypes.func.isRequired,
  onDeleteTags: PropTypes.func.isRequired
};
